import { AsyncPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective } from '@maskito/angular';

import { ErrorMessageDirective } from '../../../../directives/error-message.directive';
import { MiscModule } from '../../../../misc.module';
import { DashIfEmptyPipe } from '../../../../pipes/dash-if-empty.pipe';
import { OwnerNamePipe } from '../../../../pipes/owner-name.pipe';
import { SurfacePipe } from '../../../../pipes/surface.pipe';
import { UsdCurrencyPipe } from '../../../../pipes/usd-currency.pipe';
import { TextAreaLogsDirective } from './directives/text-area-logs.directive';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.component';

@NgModule({
  declarations: [HomePageComponent, TextAreaLogsDirective],
  imports: [
    HomePageRoutingModule,
    IonicModule,
    MiscModule,
    ReactiveFormsModule,
    MaskitoDirective,
    DatePipe,
    AsyncPipe,
    ErrorMessageDirective
  ],
  providers: [OwnerNamePipe, DashIfEmptyPipe, UsdCurrencyPipe, SurfacePipe, DatePipe]
})
export class HomePageModule {}
